module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_f_normal.93c87469.png";